import { inject } from '@angular/core';
import { Router, CanActivateFn, CanMatchFn } from '@angular/router';
import { AuthService } from '../services/auth-service';
import { hasReviewerDashboardAccess } from '../auth/permissions';

export const matchAllocator: CanMatchFn = async () => {
  const authService = inject(AuthService);
  await authService.waitForAuthState();
  if (!authService.isAuthenticated()) return false;
  await authService.waitForClaims();
  return authService.hasPermission('case_queue:manage');
};

export const matchReviewer: CanMatchFn = async () => {
  const authService = inject(AuthService);
  await authService.waitForAuthState();
  if (!authService.isAuthenticated()) return false;
  await authService.waitForClaims();
  return hasReviewerDashboardAccess(authService);
};

export function matchHasPermission(...permissions: string[]): CanMatchFn {
  return async () => {
    const authService = inject(AuthService);
    await authService.waitForAuthState();

    if (!authService.isAuthenticated()) {
      return false;
    }

    await authService.waitForClaims();
    return permissions.some((permission) => authService.hasPermission(permission));
  };
}

export function permissionGuard(...permissions: string[]): CanActivateFn {
  return async () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    await authService.waitForAuthState();

    if (!authService.isAuthenticated()) {
      return router.createUrlTree(['/login']);
    }

    await authService.waitForClaims();

    if (permissions.some((permission) => authService.hasPermission(permission))) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}
